// import Position from './Position';

export default {
  priority: 1,
  permissions: ['PositionPermissions'],
  // component: Position,
  component: load(() => import(/* webpackChunkName: "Permission-Position" */ './Position')),
  name: app.translate('routes.home.basic.permission.Position'),
  icon: 'account-card-details',
  drawer: true,
};
